import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import axios from 'src/api/Api';
import {
    GET_SHIPPING_METHODS_SUCCESS,
    GET_SHIPPING_METHODS_FAILURE,
} from '../actions';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
// export default function* getShippingMethods(action) {
//     const { isOutside } = action.payload;

//     const surgeryAccountId = yield select((state) =>
//         isOutside
//             ? state.reportShipToAddressReducer.outsideSurgeryDetails?.accountId
//                   ?.accountId
//             : state.reportShipToAddressReducer.insideSurgeryDetails?.accountId
//                   ?.accountId
//     );

//     const selectedAccountDetails = yield select((state) =>
//         isOutside
//             ? state.reportShipToAddressReducer.outsideSurgeryDetails?.accountId
//             : state.reportShipToAddressReducer.insideSurgeryDetails?.accountId
//     );

//     // const surgeryAccountId = yield select(
//     //     (state) => state.surgeryReducer?.surgeryDetails?.accountId?.accountId
//     // );

//     // const selectedAccountDetails = yield select(
//     //     (state) =>
//     //         state.surgeryReducer?.surgeryDetails &&
//     //         state.surgeryReducer?.surgeryDetails?.accountId
//     // );
//     const sapPartnerId = surgeryAccountId || selectedAccountDetails;

//     const params = {
//         orderType: action.payload.orderType,
//         shipToAcc: action.payload.shipToAcc,
//         salesOrg: action.payload.salesOrg,
//     };

//     const url = `occ/v2/${localStorage.getItem(
//         'baseSiteId'
//     )}/order/surgery/shippingmethod?${convertObjectToQueryParams({
//         ...params,
//         sapPartnerId,
//     })}`;
//     const result = yield axios.get(url).then((response) => response.data);

//     try {
//         if (isOutside) {
//             yield put({
//                 type: GET_OUTSIDE_SHIPPING_METHODS_SUCCESS,
//                 payload: {
//                     data: result.shipMethods,
//                     salesOrg: action.payload.salesOrg,
//                 },
//                 statusCode: result.statusCode,
//                 statusMessage: result.statusMessage,
//             });
//         } else {
//             yield put({
//                 type: GET_INSIDE_SHIPPING_METHODS_SUCCESS,
//                 payload: {
//                     data: result.shipMethods,
//                     salesOrg: action.payload.salesOrg,
//                 },
//                 statusCode: result.statusCode,
//                 statusMessage: result.statusMessage,
//             });
//         }
//     } catch (e) {
//         console.log(e);
//         if (!isOutside) {
//             yield put({
//                 type: GET_INSIDE_SHIPPING_METHODS_FAILURE,
//                 statusCode: errorHandler('503'),
//                 statusMessage: e.Error,
//             });
//         } else {
//             yield put({
//                 type: GET_OUTSIDE_SHIPPING_METHODS_FAILURE,
//                 statusCode: errorHandler('503'),
//                 statusMessage: e.Error,
//             });
//         }
//     }
// }
export default function* getShippingMethods(action) {
    const sapPartnerAid = yield select(
        (state) => state.surgeryReducer.surgeryDetails.accountId.accountId
    );

    const sapPartnerAccountId = yield select(
        (state) => state.surgeryReducer.surgeryDetails.accountId.accountId
    );
    const sapAccountId = yield select(
        (state) => state.consignmentReducer.surgeryDetails.accountId.accountId
    );

    const sapPartnerId = sapPartnerAid || sapPartnerAccountId || sapAccountId; // sapPartnerId1 updated from sapPartnerId to add configuration for Japan User
    // countrycode, sapPartnerIdJapanUser and sapPartnerIdResult are created to change shippin method as ber BillToId
    //  const countrycode = localStorage.getItem('countrycode')
    //  const sapPartnerIdJapanUser = yield select(
    //      (state) => state.surgeryReducer.surgeryDetails.billToId
    //  );
    //  const sapPartnerIdResult = function (){
    //      if(countrycode == 'JP'){
    //          return sapPartnerIdJapanUser
    //      }
    //      else
    //      return sapPartnerId1
    //  }
    // const sapPartnerId = sapPartnerIdResult()

    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/surgery/shippingmethod?${convertObjectToQueryParams({
        ...action.payload,
        sapPartnerId,
    })}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({
            type: GET_SHIPPING_METHODS_SUCCESS,
            payload: {
                data: result.shipMethods,
                salesOrg: action.payload.salesOrg,
                showShippingMethods: result.isValuePresent,
            },
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
        });
    } catch (e) {
        yield logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: GET_SHIPPING_METHODS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
